import { IconButton, Typography } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import Slide from "@material-ui/core/Slide";
import { TransitionProps } from "@material-ui/core/transitions";
import AddAPhotoIcon from "@material-ui/icons/AddAPhoto";
import LaunchIcon from "@material-ui/icons/Launch";
import L from "leaflet";
import icon from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";
import "leaflet/dist/leaflet.css";
import { default as React, useCallback, useState } from "react";
import "react-image-lightbox/style.css";
import { Map, Marker, Popup, TileLayer } from "react-leaflet";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import Show from "./Show";
import { CurrentPosition, Store } from "./types";
import { useLocation } from "wouter";

const marker = new L.Icon({
  iconUrl: icon,
  iconSize: [25, 41],
  iconAnchor: [13, 41],
  popupAnchor: [0, -45],
  shadowUrl: iconShadow,
  shadowSize: [30, 60],
  shadowAnchor: [8, 60],
});

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement },
  ref: React.Ref<unknown>
) {
  return <Slide direction="left" ref={ref} {...props} />;
});

export default function List(props: { tileData: Store[]; position: CurrentPosition }) {
  const [open, setOpen] = useState(false);
  const [target, setTarget] = useState<Store | undefined>();
  const [, setLocation] = useLocation();

  const handleClickOpen = (store: Store) => () => {
    setTarget(store);
    setOpen(true);
  };

  const handleClose = useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
    setOpen(false);
  }, []);

  return (
    <div>
      <Map
        center={[props.position.latitude, props.position.longitude]}
        zoom={16}
        style={{ height: "calc(100vh - 120px)" }}
      >
        <TileLayer
          attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />

        {props.tileData.map((tile) => {
          let image = "/noimage.png";
          if (tile.thumbnail !== "") {
            image = tile.thumbnail;
          } else if (tile.images.length !== 0) {
            image = tile.images[0];
          }

          return (
            <Marker key={tile.id} position={[tile.latitude, tile.longitude]} icon={marker}>
              <Popup>
                <Typography>{tile.title}</Typography>
                <IconButton
                  onClick={() => {
                    setLocation(`/upload/${tile.id}`);
                  }}
                >
                  <AddAPhotoIcon />
                </IconButton>
                {tile.images.length > 0 && (
                  <>
                    <IconButton onClick={handleClickOpen(tile)}>
                      <LaunchIcon />
                    </IconButton>
                  </>
                )}
              </Popup>
            </Marker>
          );
        })}
      </Map>

      <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
        {target && <Show {...target} handleClose={handleClose}></Show>}
      </Dialog>
    </div>
  );
}
